<template>
    <div>
        <div
            class="vertical_related"
            v-if="relatedNews && dataArray.length > 0"
        >
            <div class="section_title">
                <h3>Related News</h3>
            </div>

            <div class="list_related_vertical">
                <div
                    class="item_news item_news_vertical"
                    v-for="(data, index) in dataArray"
                    :key="index"
                >
                    <div class="box-cards">
                        <div class="card-image thumbnail-90">
                            <a :href="data.detail_url_web" :style="{ backgroundImage: 'url(' + data.thumbnail + ')' }">
                            </a>
                        </div>
                    </div>
                    <div class="wrap-card-text">
                        <div class="card-content">
                            <div>
                                <div class="card-label-sharing flex">
                                    <div class="wrap-label flex flex-center">
                                        <span><img :src="base_url+'/images/icon_calendar.png'" alt="calendar" /></span>
                                        <p class="tx-grey date-post">
                                            {{ data.date }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 class="tx-black card-title">
                                    <a :href="data.detail_url_web"
                                        @click="gtmTrackerArticle(data, 'Related News', data.title, data.date, data.id)">{{
                                        data.title
                                    }}</a>
                                </h3>
                            </div>
                            <div class="card-desc">
                                {{
                                    data.club
                                        ? data.club.name
                                        : data.domain
                                        ? data.domain
                                        : "N/A"
                                }}
                            </div>
                            <div class="share_row_ver">
                                <div
                                    class="btn-share"
                                    :id="'btn-share-'+index"
                                    :ref="'btn-share-'+index"
                                >
                                    <div class="shares">
                                      <ShareNetwork
                                          network="facebook"
                                           @open="gtmTrackerShare(data, 'Article Share' ,data.title, 'Facebook', 1,
                                                    'https://facebook.com/sharer/sharer.php?u='+ data.detail_url_web + '&title=' + data.title + '&description=' + data.summary)"
                                          :url="data.detail_url_web"
                                          :title="data.title"
                                          :description="data.summary"
                                        >
                                        <i class="ion-social-facebook"></i>
                                      </ShareNetwork>
                                      <ShareNetwork
                                          network="twitter"
                                          @open="gtmTrackerShare(data, 'Article Share' ,data.title, 'Twitter', 2,
                                                    'https://twitter.com/intent/tweet?text='+ data.title +'&url='+ data.detail_url_web)"
                                          :url="data.detail_url_web"
                                          :title="data.title"
                                          :description="data.summary"
                                        >
                                        <i class="ion-social-twitter"></i>
                                      </ShareNetwork>
                                      <ShareNetwork
                                          network="whatsapp"
                                          @open="gtmTrackerShare(data, 'Article Share' ,data.title, 'Whatsapp', 3,
                                                              'https://api.whatsapp.com/send?text='+ data.title + data.detail_url_web)"
                                          :url="data.detail_url_web"
                                          :title="data.title"
                                          :description="data.summary"
                                        >
                                        <i class="ion-social-whatsapp"></i>
                                      </ShareNetwork>
                                    </div>
                                    <a @click="showShare('btn-share-'+index)" class="sharebtn"
                                        ><span
                                            ><i
                                                class="ion-android-share-alt"
                                            ></i></span
                                    ></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end.item_news-->
            </div>

            <div class="row-button">
                <a @click="getNextPage" class="seeMore">See More</a>
            </div>
        </div>
        <!-- Dummy Data -->
        <div class="vertical_related" v-else>
            <div class="section_title">
                <h3>Related News</h3>
            </div>

            <div class="list_related_vertical">
                <div class="item_news item_news_vertical">
                    <div class="box-cards">
                        <div class="card-image">
                            <a href="#">
                                <img :src="base_url+'/images/thumb_vertical1.png'" />
                            </a>
                        </div>
                    </div>
                    <div class="wrap-card-text">
                        <div class="card-content">
                            <div>
                                <div class="card-label-sharing flex">
                                    <div class="wrap-label flex flex-center">
                                        <span><img :src="base_url+'/images/icon_calendar.png'" alt="calendar" /></span>
                                        <p class="tx-grey date-post">
                                            14 Desember 2020
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 class="tx-black card-title">
                                    <a href="#"
                                        >Tips Cari_Aman Pulang Pergi Kerja di
                                        masa Pandemi</a
                                    >
                                </h3>
                            </div>
                            <div class="card-desc">
                                Surabaya Honda Community
                            </div>
                            <div class="share_row_ver">
                                <div
                                    class="btn-share"
                                    :class="{ active: show }"
                                >
                                    <div class="shares">
                                        <a
                                            href="https://www.facebook.com/"
                                            target="_blank"
                                            ><i class="ion-social-facebook"></i
                                        ></a>
                                        <a
                                            href="http://twitter.com/"
                                            target="_blank"
                                            ><i class="ion-social-twitter"></i
                                        ></a>
                                        <a href="#" target="_blank"
                                            ><i class="ion-social-whatsapp"></i
                                        ></a>
                                    </div>
                                    <a @click="showShare" class="sharebtn"
                                        ><span
                                            ><i
                                                class="ion-android-share-alt"
                                            ></i></span
                                    ></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end.item_news-->

                <div class="item_news item_news_vertical">
                    <div class="box-cards">
                        <div class="card-image">
                            <a href="#">
                                <img :src="base_url+'/images/thumb_vertical2.png'" />
                            </a>
                        </div>
                    </div>
                    <div class="wrap-card-text">
                        <div class="card-content">
                            <div>
                                <div class="card-label-sharing flex">
                                    <div class="wrap-label flex flex-center">
                                        <span><img :src="base_url+'/images/icon_calendar.png'" alt="calendar" /></span>
                                        <p class="tx-grey date-post">
                                            14 Desember 2020
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 class="tx-black card-title">
                                    <a href="#"
                                        >Tips Cari_Aman Pulang Pergi Kerja di
                                        masa Pandemi</a
                                    >
                                </h3>
                            </div>
                            <div class="card-desc">
                                Surabaya Honda Community
                            </div>
                            <div class="share_row_ver">
                                <div
                                    class="btn-share"
                                    :class="{ active: show }"
                                >
                                    <div class="shares">
                                        <a
                                            href="https://www.facebook.com/"
                                            target="_blank"
                                            ><i class="ion-social-facebook"></i
                                        ></a>
                                        <a
                                            href="http://twitter.com/"
                                            target="_blank"
                                            ><i class="ion-social-twitter"></i
                                        ></a>
                                        <a href="#" target="_blank"
                                            ><i class="ion-social-whatsapp"></i
                                        ></a>
                                    </div>
                                    <a @click="showShare" class="sharebtn"
                                        ><span
                                            ><i
                                                class="ion-android-share-alt"
                                            ></i></span
                                    ></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end.item_news-->
                <div class="item_news item_news_vertical">
                    <div class="box-cards">
                        <div class="card-image">
                            <a href="#">
                                <img :src="base_url+'/images/thumb_vertical3.png'" />
                            </a>
                        </div>
                    </div>
                    <div class="wrap-card-text">
                        <div class="card-content">
                            <div>
                                <div class="card-label-sharing flex">
                                    <div class="wrap-label flex flex-center">
                                        <span><img :src="base_url+'/images/icon_calendar.png'" alt="calendar" /></span>
                                        <p class="tx-grey date-post">
                                            14 Desember 2020
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 class="tx-black card-title">
                                    <a href="#"
                                        >Tips Cari_Aman Pulang Pergi Kerja di
                                        masa Pandemi</a
                                    >
                                </h3>
                            </div>
                            <div class="card-desc">
                                Surabaya Honda Community
                            </div>
                            <div class="share_row_ver">
                                <div
                                    class="btn-share"
                                    :class="{ active: show }"
                                >
                                    <div class="shares">
                                        <a
                                            href="https://www.facebook.com/"
                                            target="_blank"
                                            ><i class="ion-social-facebook"></i
                                        ></a>
                                        <a
                                            href="http://twitter.com/"
                                            target="_blank"
                                            ><i class="ion-social-twitter"></i
                                        ></a>
                                        <a href="#" target="_blank"
                                            ><i class="ion-social-whatsapp"></i
                                        ></a>
                                    </div>
                                    <a @click="showShare" class="sharebtn"
                                        ><span
                                            ><i
                                                class="ion-android-share-alt"
                                            ></i></span
                                    ></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end.item_news-->

                <div class="item_news item_news_vertical">
                    <div class="box-cards">
                        <div class="card-image">
                            <a href="#">
                                <img :src="base_url+'/images/thumb_vertical4.png'" />
                            </a>
                        </div>
                    </div>
                    <div class="wrap-card-text">
                        <div class="card-content">
                            <div>
                                <div class="card-label-sharing flex">
                                    <div class="wrap-label flex flex-center">
                                        <span><img :src="base_url+'/images/icon_calendar.png'" alt="calendar" /></span>
                                        <p class="tx-grey date-post">
                                            14 Desember 2020
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 class="tx-black card-title">
                                    <a href="#"
                                        >Tips Cari_Aman Pulang Pergi Kerja di
                                        masa Pandemi</a
                                    >
                                </h3>
                            </div>
                            <div class="card-desc">
                                Surabaya Honda Community
                            </div>
                            <div class="share_row_ver">
                                <div
                                    class="btn-share"
                                    :class="{ active: show }"
                                >
                                    <div class="shares">
                                        <a
                                            href="https://www.facebook.com/"
                                            target="_blank"
                                            ><i class="ion-social-facebook"></i
                                        ></a>
                                        <a
                                            href="http://twitter.com/"
                                            target="_blank"
                                            ><i class="ion-social-twitter"></i
                                        ></a>
                                        <a href="#" target="_blank"
                                            ><i class="ion-social-whatsapp"></i
                                        ></a>
                                    </div>
                                    <a @click="showShare" class="sharebtn"
                                        ><span
                                            ><i
                                                class="ion-android-share-alt"
                                            ></i></span
                                    ></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end.item_news-->
            </div>

            <div class="row-button">
                <a @click="getNextPage" class="seeMore">See More</a>
            </div>
        </div>
    </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import { Carousel, Slide } from "vue-carousel";
export default {
    props: ["relatedNews"],
    components: {
        Carousel,
        Slide
    },

    data() {
        return {
            base_url:base_url,
            app_url:app_url,
            api_url:api_url,
            show: false,
            mobile: false,
            tlength: 25,
            dataArray: []
        };
    },
    created() {
        this.mobile = isMobile;
    },
    watch: {
        relatedNews: function(val) {
            this.dataArray.push(...this.relatedNews.relatedNews);
        }
    },
    methods: {
        // GTM Tracker
        gtmTrackerArticle(data, section, label, publishDate, articleID) {
            var data = {
                'event': 'articleEngagement',
                'eventDetail.category': 'Article Engagement',
                'eventDetail.action': 'Read More',
                'eventDetail.label': label,
                'articleId': articleID,
                'articlePublishedDate': publishDate,
                'articleAuthor': data.club ? data.club : (data.domain ? data.domain : "N/A"),
                'section': section
            }
            console.log(data);
            dataLayer.push(data);
        },
        gtmTrackerShare(data, action, title, lable, position, url) {
            var track = {
                'event': 'articleEngagement',
                'eventDetail.category': 'Article Engagement',
                'eventDetail.action': action,
                'eventDetail.label': lable,
                'position': position,
                'title': title,
                'articleId': data.id,
                'articlePublishedDate': data.date,
                'articleAuthor': data.club ? data.club : (data.domain ? data.domain : "N/A"),
                'destinationPageUrl': url,
                'articleList': 'Related News',
            };
            console.log(track);
            dataLayer.push(data)
        },
        // End GTM Tracker
          showShare(element) {
            if(element){
              let classList = this.$refs[element][0].classList;
              if(classList.value.includes("active")){
                classList.remove('active');
              }else{
                classList.add('active');
              }
            }else{
              this.show = !this.show;
            }
        },
        getNextPage() {
            this.gtmTrackerBtn();
            if(this.relatedNews.nextPageUrl){
              this.$emit("nextPage");
            }
        },
        gtmTrackerBtn() {
            var data = {
                'event': 'seeMore',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'See More Detail',
                'eventDetail.label': window.location.href
            }
            dataLayer.push(data);
        },
    }
};
</script>
<style scoped lang="scss">
.img-related{
    width: fit-content !important;
    height: 90px !important;
  border-radius: 10px;
//   object-fit: cover;
    padding-bottom: 20px;

    max-width: fit-content;
}
.thumbnail-90 a{
    display: block;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 150px;
    min-width: 150px;
}
.box-cards{
    margin-top: 15px;
    min-width: 150px;
}
.item_news.item_news_vertical{
    align-items: flex-start !important;
}
.card-title {
    margin-bottom: 5px;
    font-size: 20px;
    color: #fff;
    font-size: 20px;
    max-width: 100%;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
}
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}
.btn-share {
    position: relative;
}
.btn-share {
    margin-left: auto;
}
.btn-share a {
    font-size: 12px;
    padding-top: 3px;
    margin-top: auto;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 25px;
    height: 25px;
    line-height: auto;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}
.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}
.active .shares {
    width: 150px;
    left: 32px;
}
.active .shares {
    width: 108px;
    top: 1px;
}
.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}
.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    a {
        margin: 0 4px;
    }
}

.item_news .shares {
    // right: 42px;
    // left: inherit;
    left: 32px;
}
.card-content {
    white-space: normal;
}
.card-desc {
    margin-bottom: 20px;
}
.card-desc p {
    color: #727272;
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
}
.wrap-card-text {
    position: relative;
    padding: 20px;
    background-color: #1c1c1c;
}
.card-title {
    margin-bottom: 5px;
    font-size: 20px;
    a {
        color: #fff;
        font-size: 20px;
    }
}
.cta-card-box {
    display: flex;
}
.cta-card-box a {
    font-weight: 500;
    display: inline-block;
    padding: 5px 20px;
    font-size: 16px;
    border-radius: 10px;
    border: solid 1px #282828;
    color: #282828;
}
.cta-card-box a span {
    color: #e61b33;
}

.cta-card-box a .box-cards .cta-card-box a span {
    margin-left: 10px;
    font-size: 20px;
}
.labelActive {
    position: absolute;
    right: 20px;
    top: 20px;
}
.inner-title {
    display: flex;
    align-items: center;
}
.card-image {
    overflow: hidden;
    img {
        width: auto;
    }
}
.tips_list .row-grid {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}
.tips_list .row-grid .col-grid-50 {
    margin-bottom: 30px;
}
.item_news.item_news_vertical {
    display: flex;
    width: 100%;
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid rgba(219, 219, 219, 0.1);
    align-items: center;
}
.item_news.item_news_vertical .wrap-card-text {
    background: transparent;
}
.item_news.item_news_vertical .wrap-label p {
    margin-bottom: 0;
    margin-top: 0;
}
.item_news{
    h3{
        margin-block-start: auto;
    }
}
@media all and (max-width: 767px) {
    .box-cards{
        min-width:80px;
    }
    .thumbnail-90 a{
        height: 80px;
        min-width: 80px;
    }
    .item_news.item_news_vertical {
        align-items: normal;
    }
    .item_news.item_news_vertical .card-image {
        margin-top: 20px;
    }
    .img-related{
        width: fit-content !important;
      height: 100px !important;
    }
}
</style>
